import axios from 'axios';
import { handleResponseError } from '@/utils/apis.util';
import { removeFromStorage, saveToSession } from '@/utils/storage.util';
import { message } from 'antd';

const validateTokenUrl = 'api/web/users/check-token';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

axiosInstance.interceptors.request.use((config) => {
  if (!!localStorage.getItem('token')) {
    config.headers.common['Authorization'] =
      'Bearer ' + localStorage.getItem('token');
  }
  config.headers.common['Access-Control-Allow-Origin'] = '*';
  return config;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (!error.response) {
      message.error('Unknown error happened! Please contact admin for support');
      return handleResponseError(error);
    }
    const { data } = error.response;
    const { detailError, path } = data;

    let messageDetail = '';

    if (error.response.status === 403) {
      removeFromStorage('token');
      if (!window.location.pathname.includes('login'))
        window.location.replace('/');
    }

    if (error.response.status === 402) {
      saveToSession('checkSubscription', true);
      return 'checkSubscription';
    }

    if (detailError) {
      if (Array.isArray(detailError.message))
        messageDetail = detailError.message[0];
      else messageDetail = detailError.message;
    } else {
      messageDetail = data.message;
    }

    if (error.response.config.url === validateTokenUrl) {
      removeFromStorage('token');
      window.location.replace('/');
    }

    message.error(messageDetail);

    if (error.response.status === 400 && path.includes('subscription')) {
      return data;
    }

    return handleResponseError(error);
  }
);

export default axiosInstance;
